import { Component, OnInit, Input } from '@angular/core';
import { BillingManagementService } from '../../../service/billing-management.service';
import { InteractionType, KeyValues3, LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-prepaid-pin',
  templateUrl: './prepaid-pin.component.html',
  styleUrls: ['./prepaid-pin.component.scss']
})
export class PrepaidPinComponent implements OnInit {
  @Input() businessId = ''; @Input() interactionType: InteractionType = InteractionType.None;
  data: KeyValues3; 
  constructor(public localService: LocalService, public billingManagementService: BillingManagementService) { }

  ngOnInit(): void {
    this.onLoad();
  }

  onLoad(isForceRefresh = false) {
    if (this.businessId != '' && this.interactionType != InteractionType.None) {
      this.billingManagementService.getPrepaidDeductPin(this.businessId, this.interactionType, isForceRefresh).subscribe(result => {
        this.data = result;
      });
    }
  }
}
